import { render, staticRenderFns } from "./ContactsOverview.vue?vue&type=template&id=4f114684&scoped=true"
import script from "./ContactsOverview.vue?vue&type=script&lang=js"
export * from "./ContactsOverview.vue?vue&type=script&lang=js"
import style0 from "./ContactsOverview.vue?vue&type=style&index=0&id=4f114684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f114684",
  null
  
)

export default component.exports